const testIdPrefix = 'student-transfer-soe-modal'

export const testIDs = {
  optionAssign: `${testIdPrefix}-option-assign`,
  optionAssignAndForm: `${testIdPrefix}-option-assign-and-form`,
  modalAssignButton: 'modal-assign-button',
  modalCancelButton: 'modal-cancel-button',
}
